
import {Component, Children} from 'react';
import PropTypes from 'prop-types';


class HighchartsProvider extends Component {

  // get the service/data
  getChildContext() {
    const {executeFuncs} = this.props;

    // Register an instance of Highcharts for the application
    // It's currently only possible to have one instance of Highcharts per
    // application, because of Highcharts' design. See:
    // https://github.com/beestripes/react-highcharts-wrapper/issues/59
    const _Highcharts = require('highcharts');

    if (typeof executeFuncs !== 'undefined' && Array.isArray(executeFuncs) && executeFuncs.length) {
      executeFuncs.map(f => {
        return f(_Highcharts);
      });
    }
    return {
      // if someone down the element tree needs our context data
      // this reference will be called
      'Highcharts': _Highcharts
    };
  }

	render() {
		return Children.only(this.props.children)
	}

}

// tell React _what_ it provides
HighchartsProvider.childContextTypes = {
  Highcharts: PropTypes.object,
};

HighchartsProvider.defaultProps = {
  executeFuncs: [],
};

HighchartsProvider.propTypes = {
  executeFuncs: PropTypes.arrayOf(PropTypes.func),
};

export default HighchartsProvider;
